import React from 'react';
import { useSelector } from 'react-redux';
import ShiftRow from '../components/ShiftRow/ShiftRow';

const AssignedShifts = ({ shifts, daysOfWeek, onShiftClick, selectedDate, selectedShift }) => {
  const { employeeInfo } = useSelector((state) => state.currentUser);
  const { id: currentUserId, profileImageUrl: currentUserImage } = employeeInfo;

  return (
    <>
      {Object.entries(shifts).map(([eid, employeeShifts]) => {
        const { assignedName, assignedProfileImageUrl, name } = employeeShifts[0] || {};
        const imageToDisplay = eid === currentUserId ? currentUserImage : assignedProfileImageUrl;

        return (
          <ShiftRow
            key={eid}
            assigned={true}
            name={assignedName}
            role={name}
            image={imageToDisplay}
            shifts={employeeShifts}
            selectedShift={selectedShift}
            daysOfWeek={daysOfWeek}
            onShiftClick={onShiftClick}
            selectedDate={selectedDate}
          />
        );
      })}
    </>
  );
};

export default AssignedShifts;
